<template>
  <div id="app">
    <router-view keep-alive transition transition-mode="out-in"></router-view>
  </div>
</template>

<script>
  (function(doc, win) {
  	const docEl = doc.documentElement,
  		resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
  		recalc = function() {
  			const clientWidth = docEl.clientWidth;
  			if (!clientWidth) return;
  			if (clientWidth >= 375) {
  				docEl.style.fontSize = '100px';
  			} else {
  				docEl.style.fontSize = 100 * (clientWidth / 375) + 'px';
  			}
  		};

  	if (!doc.addEventListener) return;
  	win.addEventListener(resizeEvt, recalc, false);
  	doc.addEventListener('DOMContentLoaded', recalc, false);
  })(document, window);
</script>

<style lang="scss">
  .wh100{
    width: 100%;
    height: 100%;
  }

  *{
    margin: 0;
    padding: 0;
  }
  html,body,#app{
    @extend .wh100;
    overflow: hidden;
  }
  body{
    font: .14rem/1.0 "Microsoft Yahei";
  }
</style>



// WEBPACK FOOTER //
// App.vue?75253dab